import { CAPABILITIES } from '@/config/platform';
import InvoicesPage from '@/modules/settings/subscription/invoices-page';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_dashboard/dashboard/settings/invoices/',
)({
  /// Les factures sont celles de Stripe, le paiement du site : comme sa page
  /// d'abonnement, elles n'ont pas leur place sur les cibles des magasins.
  beforeLoad: () => {
    if (!CAPABILITIES.linkToExternalPurchase) {
      throw redirect({ to: '/dashboard/settings' });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <InvoicesPage />;
}
